export enum CodigoObjetivoFinanciamento {
  GIRO = 'G',
  INVESTIMENTO = 'I'
}

export const ObjetivosFinanciamento = [
  {
    nome: 'Empréstimo/Capital de Giro',
    codigo: CodigoObjetivoFinanciamento.GIRO
  },
  {
    nome: 'Investimento',
    codigo: CodigoObjetivoFinanciamento.INVESTIMENTO
  }
]

export const ObjetivosFinanciamentoMap = new Map<string, string> ([
  [ObjetivosFinanciamento[0].codigo, ObjetivosFinanciamento[0].nome],
  [ObjetivosFinanciamento[1].codigo, ObjetivosFinanciamento[1].nome]
])


